import React from 'react'
import '../../../styles/fontSizes.scss'
import palette from '../../../styles/palette.scss'
import "./tag.scss"

const Tag = ({textSize, type, className, optionalText}) =>{
    let color = ""
    let text = ""
    switch (type){
        case "noticias":
            color = palette.darkPurple
            text = "Noticias"
            break;
        case "pregrado":
            color = palette.darkGreen
            text = "Pregrado"
            break;
        case "posgrado":
            color = palette.darkBrown
            text = "Posgrado"
            break;
        case "profesor":
            color = palette.darkPurple
            text = "Ingresa un texto en el atributo"
            break;
        default:
            color = ""
            text = ""
    }
    
    return(
        <>
        {color !== "" && textSize ?
            <div className={`tag__container font-size--${textSize?textSize:"1"} ${className?className: ""}`}>
                <span style ={{backgroundColor: color}} className="tag__figure"></span>
                <p style ={{color: color}} className="tag__text" >{optionalText? optionalText:text}</p>
            </div>
        :""}
        </>
    )
}

export default Tag;